import { defaultIconColor } from './constants';
import { SVGComponentPropsType } from './types';

const defaultSize = 24;

export default ({ color = defaultIconColor, size = defaultSize, ...props }: SVGComponentPropsType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height={`${size}`}
    width={`${size}`}
    viewBox={`0 0 ${defaultSize} ${defaultSize}`}
    {...props}
  >
    <g stroke={color} strokeWidth="2" fill="none" fillRule="evenodd">
      <path d="M21 1H10.3333a4 4 0 0 0-2.4.8L1 7v5h12c1.1046 0 2-.8954 2-2s-.8954-2-2-2H9V7l2-2h3l2.1083 2.1083L21 7v-.1716a2 2 0 0 0-.5858-1.4142L20 5h1c1.1046 0 2-.8954 2-2s-.8954-2-2-2Z" />
      <g transform="translate(15 7)">
        <rect transform="matrix(-1 0 0 1 8 0)" width="8" height="6" rx="2" />
        <path d="M6 6v8l-2 2-2-2v-2l1-1-1-2V6" />
      </g>
    </g>
  </svg>
);
